import { ClipIcon } from '@components/icons/Clip';

import { usePageContext } from '../../../../../../providers/PageProvider';
import { Wrapper } from './styles/Wrapper';
import { useModalContext } from '@providers/ModalProvider';
import { ModalNamesEnum } from '@constants/enums/ModalNamesEnum';

export const AttachBackupButton = () => {
  const { job, manualReload } = usePageContext();

  const { openModal, closeModal } = useModalContext();

  const showBackupFilesModal = () => {
    openModal(ModalNamesEnum.AdminBackupFilesModal, {
      onSuccess: () => {
        closeModal();
        manualReload();
      },
      id: job?.id,
    });
  };

  if (!job || !job.status) {
    return null;
  }

  return (
    <Wrapper title="Attach Backup Files" onClick={showBackupFilesModal}>
      <ClipIcon />
      Attach Backup Files
    </Wrapper>
  );
};
